// @flow
import React from 'react'

const SingleCopy = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12">
      <g fill="none" fillRule="evenodd">
        <path d="M0-2h16v16H0z" />
        <g stroke="#4A5665" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5">
          <path d="M1.5 4.5h10V11h-10z" />
          <path d="M3.5 1.5h11v8" />
        </g>
      </g>
    </svg>
  )
}

export default SingleCopy



// WEBPACK FOOTER //
// ./src/components/Icons/SingleCopy.js